// extracted by mini-css-extract-plugin
export default {"mainCanvass":"SideBar_mainCanvass__HoCvk","linkList":"SideBar_linkList__4TVn4"};